import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import Container from "../../components/layouts/Container";
import { ContextLanguage } from "../../context/Context.Language";

import api from "../../utils/useApi";
import {
  RETURN_SAME_DAY,
  RETURN_TIME,
  SYMBOL_CURRENCY,
  TEXT_ADDRESS,
  TEXT_MY_ORDERS,
  TEXT_ORDER,
  TEXT_PICKUP,
  TEXT_RETURN,
  TEXT_TOTAL,
} from "../../utils/useConstants";
import {
  FunctionChangeFormatDateAgain,
  FunctionFormatCurrency,
  FunctionFormatDateToString,
  toISO,
  weekdays,
} from "../../utils/useFunction";
import {
  STYLE_DATE_ORDER_DETAILS,
  STYLE_DETAILS_ADDONS_BUSKET_ORDER,
  STYLE_MAX_WIDTH_DESKTOP,
  STYLE_PADDING_NO_MB,
  STYLE_PICKUP_ORDER,
  STYLE_SECTION_ORER_DETIALS,
  STYLE_TITLE_ORDER_NAME_DETAILS,
  STYLE_TITLE_SEMIBOLD,
  STYLE_TITLE_SEMIBOLD_ORDER_SPACIAL,
} from "../../utils/useStyle";
import OrderGetPaymentImage from "./functions/Order.GetPaymentImage";
import OrderGetStyleStatus from "./functions/Order.GetStyleStatus";
import ProgramGoBack from "../task/render/Program.GoBack";
import { DateTime } from "luxon";
import { ARRAY_DATE_WEEK_TH } from "../basket/function/Busket.GenerateDate";

export const STYLE_SUB_TEXT_DETAIL_LIGHTGRAY = (language) => {
  if (language === "TH") {
    return "text-sm md:text-[16px] text-laundry-gray-80 font-normal w-1/2 text-end leading-6";
  } else {
    return "text-[12px] md:text-[14px] text-laundry-gray-80 font-normal w-1/2 text-end leading-6";
  }
};
export const STYLE_SUB_TEXT_DETAIL_LIGHTGRAY_DATE = (language) => {
  if (language === "TH") {
    return "text-xs-th text-laundry-gray-80 font-normal w-1/2 text-end leading-6";
  } else {
    return "text-xs text-laundry-gray-80 font-normal w-1/2 text-end leading-6";
  }
};
export const STYLE_SUB_TEXT_DETAIL_LIGHTGRAY_ORDER_DETAILS = (language) => {
  if (language === "TH") {
    return "text-xs-th text-laundry-gray-80 font-normal w-1/2 text-end leading-6";
  } else {
    return "text-xs text-laundry-gray-80 font-normal w-1/2 text-end leading-6";
  }
};

const getThisDay = (date, language) => {
  // console.log("date", date);
  // const day = new Date(toISO(date));
  const day = DateTime.fromISO(toISO(date)).weekday;
  // const day = DateTime.fromISO(date).weekday;
  let res = weekdays[day];

  if (language === "TH") {
    res = ARRAY_DATE_WEEK_TH[day];
  }

  return res;
};

export const PageDetail = ({
  api,
  path,
  renderBody,
  params,
  renderLoading,
  initialState,
  method,
}) => {
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");
  const [state, setState] = React.useState(initialState);
  const [loaded, setLoaded] = React.useState(false);

  React.useEffect(() => {
    FunctionLoadData();
  }, [api, path, params]);

  const FunctionLoadData = async () => {
    if (api && path && params.id.length === 24 && !loaded) {
      setLoading(true);

      try {
        setLoaded(true);

        if (method === "GET") {
          const { data } = await api.get(`${path}/${params.id}`);
          setData(data);
        } else if (method === "POST") {
          const { data } = await api.post(`${path}/${params.id}`);
          setData(data);
        }

        // setData(data[path.slice(1, path.length - 1)]);
      } catch (error) {
        setError(error);
        console.log("ERROR TO LOAD DATA : ", error);
      } finally {
        setLoading(false);
      }
    }
  };

  if (loading && renderLoading) {
    return <React.Fragment>{renderLoading}</React.Fragment>;
  }

  if (renderBody) {
    return (
      <React.Fragment>
        {renderBody({
          data,
          loading,
          refetch: FunctionLoadData,
          error,
          state,
          setState,
        })}
      </React.Fragment>
    );
  } else {
    return <React.Fragment>{renderLoading}</React.Fragment>;
  }
};

const OrderDetail = React.memo(() => {
  const { language } = React.useContext(ContextLanguage);
  const params = useParams();
  const navigate = useNavigate();

  const [loaded, setLoaded] = React.useState(false);

  // const { user } = useSelector((state) => state.auth);

  // const setOrders = SystemStoreOrders((state) => state.setOrders);

  // React.useEffect(() => {
  //   let mounted = true;

  //   if (user && setOrders) {
  //     FunctionLoadMyOrder(setOrders);
  //   } else {
  //     setOrders([]);
  //   }

  //   return () => {
  //     mounted = false;
  //   };
  // }, [user, setOrders]);

  // const FunctionLoadMyOrder = async (setOrders) => {
  //   try {
  //     const { data } = await api.post("/orders/get", {
  //       phone_number: user?.phone_number,
  //     });
  //     setOrders(data?.orders);
  //   } catch (error) {
  //     console.log("error", error);
  //   }
  // };

  return (
    // <div className={``}>
    <div className={loaded ? "" : "w-screen h-screen bg-white"}>
      <PageDetail
        api={api}
        mode="detail"
        path="/orders"
        params={params}
        method="GET"
        renderLoading={
          <div className="w-[100svh] h-[100svh] bg-white">loading.</div>
        }
        initialState={true}
        renderBody={({ data: { order }, state, setState }) => {
          if (order) {
            setLoaded(true);

            const hasMyShose =
              order?.programs?.some(
                (item) => item?.master_type === "My Shoes"
              ) || false;

            return (
              <div
                className={`flex flex-col justify-between  md:min-h-full overflow-x-hidden  md:bg-laundry-borderbottomline relative  mb-6 md:mb-0`}
              >
                <Container>
                  <div
                    id="card-order"
                    className={`${STYLE_MAX_WIDTH_DESKTOP} ${STYLE_PADDING_NO_MB}`}
                  >
                    <div
                      className={`bg-white md:ordershadow px-4 md:px-6 pb-4 md:pb-[20px] rounded-xl h-full`}
                    >
                      <ProgramGoBack
                        onClick={() => {
                          navigate("/MyOrders");
                        }}
                        title={TEXT_MY_ORDERS[language]}
                        hiddenButton={!state}
                      />
                      <OrderGetStyleStatus input={order?.status} />
                      <div className="">
                        <div className={`flex justify-between mt-6`}>
                          <div
                            className={`${STYLE_TITLE_ORDER_NAME_DETAILS(
                              language
                            )}`}
                          >
                            <div className="flex group-hover:underline break-all">
                              {TEXT_ORDER[language]} No. {order?.order_number}
                            </div>
                            <div
                              className={`${STYLE_DATE_ORDER_DETAILS(
                                language
                              )}`}
                            >
                              {FunctionFormatDateToString(
                                order?.createdAt,
                                language
                              )}{" "}
                              {language === "TH" ? "น." : ""}{" "}
                            </div>
                          </div>
                        </div>

                        <div className={STYLE_SECTION_ORER_DETIALS}>
                          <div className={STYLE_PICKUP_ORDER(language)}>
                            {TEXT_PICKUP[language]}
                          </div>
                          <div
                            className={STYLE_SUB_TEXT_DETAIL_LIGHTGRAY(
                              language
                            )}
                          >
                            <span className="my-auto">
                              {" "}
                              {getThisDay(order?.pickup_date, language)}
                              {language === "TH" ? "" : ","}{" "}
                            </span>
                            {FunctionChangeFormatDateAgain(order?.pickup_date)}

                            {/* ,{" "} */}
                            {/* {order?.pickup_time} */}
                          </div>
                        </div>
                        <div className={STYLE_SECTION_ORER_DETIALS}>
                          <div className={STYLE_PICKUP_ORDER(language)}>
                            {TEXT_RETURN[language]}{" "}
                            {language === "TH"
                              ? `ภายใน ${
                                  order?.same_day_service || hasMyShose
                                    ? `${RETURN_SAME_DAY}:00 น. `
                                    : `${RETURN_TIME}:00 น. `
                                }`
                              : `by ${
                                  order?.same_day_service || hasMyShose
                                    ? `${RETURN_SAME_DAY}:00`
                                    : `${RETURN_TIME}:00`
                                }`}
                          </div>
                          <div
                            className={STYLE_SUB_TEXT_DETAIL_LIGHTGRAY(
                              language
                            )}
                          >
                            <span className="my-auto">
                              {" "}
                              {getThisDay(order?.return_date, language)}
                              {language === "TH" ? "" : ","}{" "}
                            </span>
                            {FunctionChangeFormatDateAgain(order?.return_date)}
                            {/* ,{" "} */}
                            {/* {order?.return_time} */}
                          </div>
                        </div>
                        <div className={`${STYLE_SECTION_ORER_DETIALS}`}>
                          <div className={STYLE_PICKUP_ORDER(language)}>
                            {TEXT_ADDRESS[language]}
                          </div>
                          <div
                            className={` text-xs md:text-sm text-laundry-gray-80 font-normal w-3/4 md:w-1/2 text-end  leading-5 ${
                              language === "TH"
                                ? "font-NotoSansThai"
                                : "font-Poppins"
                            }`}
                          >
                            <div>{order?.address?.name}</div>
                            <div> {order?.address?.formatted_address}</div>
                          </div>
                        </div>
                        {order?.same_day_service && (
                          <div
                            className={` flex justify-between mt-5 md:mt-6 `}
                          >
                            <div
                              className={`flex text-laudry-gray-200 font-bold md:font-semibold leading-6 text-base ${
                                language === "TH"
                                  ? "font-NotoSansThai"
                                  : "font-Poppins"
                              }`}
                            >
                              {language === "TH"
                                ? "บริการส่งคืนด่วนในวันเดียวกัน"
                                : "Same Day Express Service"}
                            </div>
                            <div
                              className={`text-laudry-gray-200 font-bold md:font-semibold leading-6 text-base`}
                            >
                              <span className="font-NotoSansThai">
                                {SYMBOL_CURRENCY}
                              </span>
                              <span className="font-Poppins">
                                {FunctionFormatCurrency(
                                  order?.same_day_service_price
                                )}
                              </span>
                            </div>
                          </div>
                        )}
                        {order?.programs?.map((program, index) => {
                          return (
                            <div key={`key-of-program-${index}`}>
                              <div
                                className={` flex justify-between mt-5 md:mt-6 `}
                              >
                                <div
                                  className={`flex text-laudry-gray-200 font-bold md:font-semibold leading-6 text-base font-Poppins`}
                                >
                                  {program?.master_type}{" "}
                                  <span className="font-normal mx-1"> | </span>{" "}
                                  {program?.size}
                                </div>
                                <div
                                  className={`text-laudry-gray-200 font-bold md:font-semibold leading-6 text-base`}
                                >
                                  <span className="font-NotoSansThai">
                                    {SYMBOL_CURRENCY}
                                  </span>
                                  <span className="font-Poppins">
                                    {FunctionFormatCurrency(program?.price)}
                                  </span>
                                </div>
                              </div>
                              <div className="text-laundry-gray-80 text-10  leading-5 font-normal">
                                {language === "EN" ? (
                                  <div className="font-Poppins text-xs md:text-xs">
                                    {program?.name_en}
                                  </div>
                                ) : (
                                  <div className="font-NotoSansThai text-xs-th md:text-xs-th">
                                    {program?.name_th}
                                  </div>
                                )}
                              </div>
                              {program?.addons?.map((addon, index) => {
                                return (
                                  <div
                                    key={`key-of-addon-${index}`}
                                    className={STYLE_DETAILS_ADDONS_BUSKET_ORDER(
                                      language
                                    )}
                                  >
                                    <div
                                      className={`text-laudry-gray-200 font-normal leading-6 text-sm md:text-base `}
                                    >
                                      {language === "EN" ? (
                                        <div className="font-Poppins">
                                          {addon?.name_en}
                                        </div>
                                      ) : (
                                        <div className="font-NotoSansThai">
                                          {addon?.name_th}
                                        </div>
                                      )}
                                    </div>
                                    <div
                                      className={`text-laundry-gray-200 text-base"`}
                                    >
                                      <span className="mr-[0.25px] font-NotoSansThai">
                                        {SYMBOL_CURRENCY}
                                      </span>
                                      <span className="font-Poppins">
                                        {FunctionFormatCurrency(
                                          addon[
                                            String(
                                              program?.size
                                            ).toLocaleLowerCase()
                                          ] || addon?.price
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          );
                        })}
                        {order?.water?._id && (
                          <div
                            className={` flex justify-between mt-5 md:mt-6 `}
                          >
                            <div
                              className={`flex text-laudry-gray-200 font-bold md:font-semibold leading-6 ${
                                language === "TH"
                                  ? "font-NotoSansThai text-base-th"
                                  : "font-Poppins text-base"
                              }`}
                            >
                              {/* {language === "TH"
                              ? "น้ำดื่มฟิน"
                              : "Finn Drinking Water"}
                            <span className="font-normal mx-1"> | </span>{" "} */}
                              {language === "TH"
                                ? order?.water?.name_th
                                : order?.water?.name_en}
                            </div>
                            <div
                              className={`text-laudry-gray-200 font-bold md:font-semibold leading-6 text-base`}
                            >
                              <span className="font-NotoSansThai">
                                {SYMBOL_CURRENCY}
                              </span>
                              <span className="font-Poppins">
                                {FunctionFormatCurrency(order?.water?.price)}
                              </span>
                            </div>
                          </div>
                        )}
                        {order?.water?._id && (
                          <div className="text-laundry-gray-80  leading-5 font-normal">
                            {language === "EN" ? (
                              <div className="font-Poppins text-xs">
                                {order?.water?.description_en}
                              </div>
                            ) : (
                              <div className="font-NotoSansThai text-xs-th">
                                {order?.water?.description_th}
                              </div>
                            )}
                          </div>
                        )}

                        <div className="  border-b border-[#D9DBE9] py-2"></div>
                        <div
                          className={`${STYLE_SECTION_ORER_DETIALS} md:h-10 items-center`}
                        >
                          <div
                            className={STYLE_TITLE_SEMIBOLD_ORDER_SPACIAL(
                              language
                            )}
                          >
                            {TEXT_TOTAL[language]}
                            {/* <span className="text-sm">({TEXT_INCL_VAT})</span> */}
                          </div>
                          <div className={`flex items-center`}>
                            <div className=" flex-none">
                              <OrderGetPaymentImage
                                input={order?.payment_method}
                              />
                            </div>
                            <div
                              className={`flex-shrink   ${STYLE_TITLE_SEMIBOLD(
                                language
                              )} `}
                            >
                              <span className="font-NotoSansThai">
                                {SYMBOL_CURRENCY}
                              </span>
                              <span className="font-Poppins">
                                {FunctionFormatCurrency(order?.total)}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Container>

                {/* <PDFViewer
                  style={{
                    width: "100%",
                    height: "100vh",
                  }}
                >
                  <NativeElement />
                </PDFViewer> */}

                {/* <div className={` w-full bg-white`}>
                  <div
                    className={` ${STYLE_BOTTOM_BAR} ${STYLE_MAX_WIDTH_DESKTOP}`}
                  >
                    <PDFDownloadLink
                      fileName={`Order No. ${order?.order_number}.pdf`}
                      document={<NativeElement />}
                    >
                      <BlueButton
                        title={TEXT_SAVE_TO_GALLERY[language]}
                        className={`${STYLE_BUTTON_BAR_BLUE(language)} `}
                      />
                    </PDFDownloadLink>
                  </div>
                </div> */}
              </div>
            );
          } else {
            return <div></div>;
          }
        }}
      />
    </div>
  );
});
export default OrderDetail;
